// src/features/quotation/pages/QuotationPage.jsx
import React from "react";
import QuotationManager from "../components/QuotationManager";

const QuotationPage = () => {
  return <QuotationManager />;
};

export default QuotationPage;
